const types = {
    SET_LIST_CREDIT: '[CREDIT] SET LIST CREDIT',
    SET_LIST_GROUPS: '[CREDIT] SET LIST GROUPS',
    SET_CREDIT_LIVE: '[CREDIT] SET CREDIT LIVE'
}

export {
    types
}